import { Capacitor } from '@capacitor/core';
import { normalizeNativeAccountReturnPath } from '@/utils/nativeAccountCompletion';

export function getUpgradePath(
  returnPath: string,
  isNativeRuntime = Capacitor.isNativePlatform(),
): string {
  const normalizedReturnPath = normalizeNativeAccountReturnPath(
    returnPath,
    '/programs',
  );
  const entryPath = isNativeRuntime ? '/upgrade' : '/pricing';
  return `${entryPath}?returnTo=${encodeURIComponent(normalizedReturnPath)}`;
}
